import {IconButton, Tooltip, useTheme} from "@mui/material";
import {FiArrowLeft} from "react-icons/fi";
import {useLocation, useNavigate} from "react-router-dom";

const BackButton = ({fallbackRoute}) => {
  const {state} = useLocation();
  const navigate = useNavigate();
  const theme = useTheme();
  const from = state?.from;

  const handleBack = () => {
    if (from?.pathname) {
      navigate(from.pathname, {state: {listState: from.listState}});
    } else {
      navigate(fallbackRoute);
    }
  };

  return (
    <Tooltip title="Volver">
      <IconButton aria-label="volver" onClick={handleBack} sx={{color: theme.palette.windowScreen.title}}>
        <FiArrowLeft />
      </IconButton>
    </Tooltip>
  );
};

export default BackButton;
